import styled, { keyframes } from 'styled-components';
import { color, spacing, typography } from '~/theme';

const $spinnerSize = '3rem';
const $duration = '1.5s';
const $offset = '1, 200';
const $dasharray = '89, 200';

export const RelativeContainer = styled.div`
    position: relative;
`;

export const SpinnerOverlay = styled.div<{ $hidden: boolean; $blockPage: boolean }>`
    display: ${props => (props.$hidden ? 'none' : 'flex')};
    position: ${props => (props.$blockPage ? 'fixed' : 'absolute')};
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.7);
    z-index: 9999;
`;

const Spin = keyframes`
	from {transform:rotate(0deg);}
    to {transform:rotate(360deg);}
`;

const Dash = keyframes`
    0% {
		stroke-dasharray: ${$offset};
		stroke-dashoffset: 0;
	}
	50% {
		stroke-dasharray: ${$dasharray};
		stroke-dashoffset: -35px;
	}
	100% {
		stroke-dasharray: ${$dasharray};
		stroke-dashoffset: -124px;
	}
`;

export const SpinnerContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    width: 100%;
    height: 100%;
    transform: translateY(-50%);

    p {
        color: ${color.palette.greyscale70};
        font-family: ${typography.fontSecondary};
        font-weight: ${typography.fontWeightBold};
        margin: ${spacing.spacing2} ${spacing.spacing0} ${spacing.spacing0};
    }
`;

export const StyledSpinner = styled.svg<{ $size: 'default' | 'small' }>`
    width: ${props => (props?.$size === 'default' ? $spinnerSize : `calc(${$spinnerSize} / 2)`)};
    height: ${props => (props?.$size === 'default' ? $spinnerSize : `calc(${$spinnerSize} / 2)`)};
    overflow: visible;
    animation: ${Spin} ${$duration} linear infinite;

    circle {
        stroke-dasharray: ${$offset};
        stroke-dashoffset: 0;
        stroke-linecap: round;
        stroke: ${color.palette.greyscale70};
        animation: ${Dash} ${$duration} ease-in-out infinite;
    }
`;

export default {
    SpinnerOverlay,
    StyledSpinner,
};
